class SelectToggle {
  /**
   * Create new select toggle
   * @param {HTMLSelectElement} select Select element
   */
  constructor (select) {
    this.select = select
    this.options = select.querySelectorAll('option')
    this.targets = []

    this.options.forEach(option => {
      const target = option.dataset.target

      if (target) {
        this.targets.push(document.querySelector(`#${target}`))
      }
    })
  }

  /**
   * Initialize select toggle
   */
  init () {
    this.select.addEventListener('change', () => {
      this.setState(this.select.selectedOptions[0].dataset.target)
    })

    // Pre-select target
    const target = this.select.selectedOptions[0].dataset.target

    if (target) {
      this.setState(target)
    }
  }

  /**
   * Set target states
   * @param {String} id Target ID
   */
  setState (id) {
    this.targets.forEach(target => {
      const input = target.querySelector('input.js-set-required')
      if (target.id === id) {
        target.hidden = false
        if (input) {
          input.required = true
        }
      } else {
        target.hidden = true
        if (input) {
          input.required = false
        }
      }
    })
  }
}

const elements = document.querySelectorAll('.js-select-toggle')
elements.forEach(element => new SelectToggle(element).init())
